import { Box, Href, Icon, Text } from '@factorialco/deprecated-design-system'

interface Props {
  name: string
  path: string
}

const AttachmentBox = ({ name, path }: Props) => {
  return (
    <Href href={path} target="_blank" download={name}>
      <Box
        border={{
          all: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
        borderRadius={{
          all: 'abs008',
        }}
        paddingY="s16"
        paddingX="s24"
        width="full"
      >
        <Box flexDirection="row" gap="s16" justifyContent="spaceBetween" flexNoShrink>
          <Box flexDirection="row" gap="s8" overflowX="hidden">
            <Box minWidth="s24">
              <Icon.Medium icon="file" color="grey600" />
            </Box>
            <Box overflowX="hidden">
              <Text.Normal size="300" ellipsis>
                {name}
              </Text.Normal>
            </Box>
          </Box>
          <Box minWidth="s24">
            <Icon.Medium icon="download" color="grey600" />
          </Box>
        </Box>
      </Box>
    </Href>
  )
}

export default AttachmentBox
